export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '0fce636d-b82e-4b7f-9716-879889e9f116';
export const MODAL_CLOSE_SEC = 2.5;
